/**
 * Component: Masonry
 * ------------------------------------------------------------------------------
 * Instantiate a masonry layout using Macy.
 *
 * @namespace Masonry
 */

import log from 'salvo-lite/log'

import Macy from 'macy'
import breakpoints from '../helpers/breakpoints'

class Masonry {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            container: '[data-masonry]',
            breakAt: {
                [Number(breakpoints.medium.replace('px', ''))]: 2
            },
            columns: 4,
            trueOrder: false,
            waitForImages: false,
            ...JSON.parse(elem.getAttribute('data-masonry') || '{}')
        }
        this._masonry = {}
        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Initialise carousel component.
     */
    onInit () {
        this._masonry = new Macy(this._settings)
        console.log(this._masonry)
    }

    /**
     * Trigger reload events.
     */
    reload () {
        this._masonry.reInit()
    }

    /**
     * Trigger resize events.
     */
    resize () {
        this._masonry.recalculate()
    }

    /**
     * Destroy instance.
     */
    destroy () {
        this._masonry.remove()
    }

    // /**
    //  * Expose public interface.
    //  */
    // return Object.freeze({
    //   init,
    //   reload,
    //   resize,
    //   destroy,
    // });
}

export default Masonry



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Masonry.js